import React, { useEffect, useState } from "react";
import Offer from "./offer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingBag,
  faHeart,
  faRuler,
} from "@fortawesome/free-solid-svg-icons";
import ExpandSection from "./expandSection";
import { useNavigate } from "react-router-dom";
import DeliverySection from "./deliverySection";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import SizeChart from "./sizeChart";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProductInfo = ({ product }) => {
  const sizes = ["S", "M", "L", "XL", "XXL"];
  const [selectedSize, setSelectedSize] = useState(null);
  const [userId, setUserId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [wishlist, setWishlist] = useState(false);
  const [token, setToken] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("STITCHD_ID");
    if (token) {
      setToken(token);
      const decoded = jwtDecode(token);
      setUserId(decoded._id);
    }
  }, [token]);

  useEffect(() => {
    const fetchWishlistItems = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/user/${userId}/wishlist`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        response.data.wishlist.forEach((item) => {
          if (item._id === product._id) {
            setWishlist(true);
          }
        });
      } catch (error) {
        console.error("Error fetching wishlist items:", error);
      }
    };

    if (userId) {
      fetchWishlistItems();
    }
  }, [userId, product]);

  const handleAddToBag = async () => {
    if (!token) {
      navigate("/signin");
      return;
    }
    if (!selectedSize) {
      return;
    }

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_URL}/user/cart/${userId}/${product._id}`,

        { size: selectedSize },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Product added to cart", {
        position: "bottom-center",
        autoClose: 1000,
      });
    } catch (error) {
      console.error("Error adding product to cart:", error);
      toast.error("Error adding product to cart", {
        position: "bottom-center",
        autoClose: 1000,
      });
    }
  };

  const handleAddToWishlist = async () => {
    if (!token) {
      navigate("/signin");
      return;
    }
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_URL}/user/wishlist/${userId}/${product._id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setWishlist(true);
    } catch (error) {
      console.error("Error adding product to wishlist:", error);
      toast.error("Error adding product to wishlist", {
        position: "bottom-center",
        autoClose: 1000,
      });
    }
  };

  const handleRemoveWishlist = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_URL}/user/wishlist/${userId}/${product._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setWishlist(false);
    } catch (error) {
      toast.error("Error removing product from wishlist", {
        position: "bottom-center",
        autoClose: 1000,
      });
    }
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="flex flex-col w-full lg:w-1/2 lg:pl-16 mt-6 lg:mt-20">
      <ToastContainer />
      <p className="md:text-4xl text-2xl font-futura font-normal mb-6 text-center lg:text-left">
        {product.name}
      </p>
      <p className="text-gray-700 font-twentieth-century text-center lg:text-left text-lg font-light">
        ₹{product.price}
      </p>
      <p className="text-gray-700 font-twentieth-century text-center lg:text-left text-md font-light">
        (incl. of all taxes)
      </p>
      <Offer />
      <div className="h-px w-full bg-gray-500 my-8"></div>
      <div>
        <h4 className="text-lg font-medium tracking-widest font-twentieth-century text-center lg:text-left">
          SIZE
        </h4>
        <div className="flex justify-center lg:justify-start space-x-2 mt-2">
          {sizes.map((size) => (
            <div
              key={size}
              className={`px-3 py-2 font-twentieth-century border border-black rounded-lg font-light cursor-pointer text-xs hover:shadow-xl hover:bg-black hover:text-white ${
                selectedSize === size ? "bg-black text-white" : "text-black"
              }`}
              onClick={() => setSelectedSize(size)}
            >
              {size}
            </div>
          ))}
        </div>
        <button
          className="h-10 w-full my-4 text-gray-700 bg-red-50 font-light text-center mt-4 text-sm tracking-widest flex items-center justify-center hover:bg-red-100"
          onClick={() => openModal()}
        >
          <FontAwesomeIcon icon={faRuler} className="mr-2" /> SIZE CHART
        </button>

        <div className="py-10">
          <button
            onClick={handleAddToBag}
            className={`h-12 font-mono w-full bg-black text-white font-medium text-center mt-4 text-md tracking-widest flex items-center justify-center ${
              selectedSize
                ? "hover:bg-gray-600 cursor-pointer"
                : "bg-gray-300 cursor-not-allowed"
            }`}
            disabled={!selectedSize}
          >
            <FontAwesomeIcon icon={faShoppingBag} className="mr-2" />{" "}
            {selectedSize ? "ADD TO BAG" : "SELECT SIZE"}
          </button>
          {!wishlist && (
            <button
              className="h-12 font-mono w-full border border-black bg-stone-50 font-light text-center mt-4 text-md tracking-widest flex items-center justify-center hover:bg-stone-200"
              onClick={handleAddToWishlist}
            >
              <FontAwesomeIcon icon={faHeart} className="mr-2" /> ADD TO
              WISHLIST
            </button>
          )}
          {wishlist && (
            <button
              className="h-12 font-mono w-full border border-black bg-black font-light text-center mt-4 text-md tracking-widest flex items-center justify-center text-red-600"
              onClick={handleRemoveWishlist}
            >
              <FontAwesomeIcon icon={faHeart} className="mr-2" /> ADDED TO
              WISHLIST
            </button>
          )}
        </div>
      </div>
      <ExpandSection product={product} />
      <DeliverySection />
      <SizeChart isOpen={modalIsOpen} onClose={closeModal} order={product} />
    </div>
  );
};

export default ProductInfo;
